import React from 'react';

export class Audio extends React.Component {
    render() {
        return (
            <div>
                <audio className="audio-element">
                    <source src="https://4325477.app.netsuite.com/core/media/media.nl?id=6083009&c=4325477&h=4WA5u-TgTMRi9DkQ6Ldc7DsB_556UctaX1uJjH_z21IKTYvC&_xt=.mp3"></source>
                </audio>
                <audio className="audio-element-scan-slot">
                    <source src="https://4325477.app.netsuite.com/core/media/media.nl?id=6083018&c=4325477&h=-7v53zD0x9L1Mn-JODD34KGmT8izkCdDBHkTXMbacA_L1h7U&_xt=.mp3"></source>
                </audio>
                <audio className="audio-element-failure">
                    <source src="https://4325477.app.netsuite.com/core/media/media.nl?id=6083011&c=4325477&h=MnzT5mC59rP7_sUryKdzt1_PU6nwmLkCf7Vstk5JucSuIgI5&_xt=.mp3"></source>
                </audio>
                <audio className="audio-element-mi">
                    <source src="https://4325477.app.netsuite.com/core/media/media.nl?id=6083012&c=4325477&h=JCYmZvZxQV7KTSKg00WETpF7yv0PqtU-IwkdsnvJovq6-q8o&_xt=.mp3"></source>
                </audio>
                <audio className="audio-element-ghost">
                    <source src="https://4325477.app.netsuite.com/core/media/media.nl?id=6083016&c=4325477&h=_XwSrICLMF4chEqWE68IYBGJYwk00dinZxfprXmFpdzwi9no&_xt=.mp3"></source>
                </audio>
                <audio className="audio-element-coin">
                    <source src="https://4325477.app.netsuite.com/core/media/media.nl?id=6083017&c=4325477&h=otpinbdVx0HGlbHjSsjuBMajhfWIhMLTFMlD1ZRta7A6AMbl&_xt=.mp3"></source>
                </audio>
            </div>
        );
    }
}
